import { MaybeRef, computed, ref, unref } from 'vue'
import { BUDGET_TYPE } from '@/components/Job/constants'
import { useJobFormStore } from '@/components/Job/Edit/store/jobFormStore'
import { RateCardBand } from '@/components/Job/composables/useRateCardBandGuidance'

export function useRateCardPrefill(options: {
  band: MaybeRef<RateCardBand>
  enabled: MaybeRef<boolean>
  canActOnBand: MaybeRef<boolean>
}) {
  const store = useJobFormStore()
  const previous = ref<{ minimumRate: string; maximumRate: string } | null>(null)

  const apply = () => {
    if (
      !unref(options.enabled) ||
      !unref(options.canActOnBand) ||
      store.form.budgetType !== BUDGET_TYPE.RATE_RANGE
    ) {
      return
    }

    const band = unref(options.band)
    if (!band || band.minimum == null || band.maximum == null) return

    previous.value = {
      minimumRate: store.form.minimumRate,
      maximumRate: store.form.maximumRate,
    }

    store.form.minimumRate = `${band.minimum}`
    store.form.maximumRate = `${band.maximum}`
  }

  const canUndo = computed(() => previous.value !== null)

  const undo = () => {
    if (!previous.value) return

    store.form.minimumRate = previous.value.minimumRate
    store.form.maximumRate = previous.value.maximumRate
    previous.value = null
  }

  return { apply, canUndo, undo }
}
